import {
  LoadErgoRoles,
  LoadErgoRolesComplete,
  LoadErgoRolesFailed,
  LoadRoles,
  LoadRolesComplete,
  LoadRolesFailed,
} from './role-load.actions';

export enum RoleActionType {
  LoadRoles = 'LOAD_ROLES',
  LoadRolesComplete = 'LOAD_ROLES_COMPLETE',
  LoadRolesFailed = 'LOAD_ROLES_FAILED',

  LoadErgoRoles = 'LOAD_ERGO_ROLES',
  LoadErgoRolesComplete = 'LOAD_ERGO_ROLES_COMPLETE',
  LoadErgoRolesFailed = 'LOAD_ERGO_ROLES_FAILED',
}

export type RoleActions =
  LoadRoles |
  LoadRolesComplete |
  LoadRolesFailed |
  LoadErgoRoles |
  LoadErgoRolesComplete |
  LoadErgoRolesFailed;
